import { searchActions } from '../../services';

export const searchDispatcher = dispatch => ( {
  searchProducts: query => dispatch( { type: searchActions.GETPRODUCTS, query } ),
  searchProductsBusy: () =>  dispatch( { type: 'dispatch-busy', action: 'activeSearch-active' } ),
  searchProductsComplete: () =>  dispatch( { type: 'dispatch-complete', action: 'activeSearch-active' } ),
  searchCategories: ( topNode, query ) => dispatch( { type: searchActions.GETCATEGORIES, query, topNode } ),
  resetSearch: (query) => dispatch( { type: searchActions.RESET, query } ),
  setCurrentSearchString:(query) => dispatch( { type: searchActions.SETSEARCHKEY, query } )
} );
